<template>
  <div class="container">
        <div class="panel">
            <div class="panel-heading">
                <div class="panel-label">
                    <h3>Selected shops: {{selectedShops.length}}</h3>
                </div>
            </div>
            <div class="panel-body">
                <div class="shops">
                    <div class="shop-items mb-2" v-for="shop in selectedShops" :key="shop.id">
                        <img :src="shop.iconURL" width="20" class="mr-1"/> 
                        <span> {{shop.name}} </span>
                    </div>
                </div>
            </div>
        </div>
    <envs
      :envConfigs.sync="envConfigs"
      @bardcode="barcodeChanged"
      @currency="currencyChanged"
      @showEAN="showEanChanged"
      @proxy="proxyChanged"
      @testregistry="testregistryChanged"
      @printcubeBrand="printcubeBrandChanged"
      :displayEnvs="true"
    ></envs>
    <button
          type="button"
          class="btn btn-primary"
          name="save"
          v-on:click="save()"
        >{{$t('UI.save')}}</button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import ProductsTable from '../Products/ProductsTable';
import Envs from "../../../components/Panel/Registration/Shops/SubForms/Envs";
export default {
  name: "EnvsBulk",
  components: {
    // ProductsTable
    Envs
  },
  data() {
    return {
      envConfigs: {},
      shop: {},
      loadbalancer: ''
    };
  },
  computed: {
    ...mapGetters({
      selectedShops: "getSelectedShops"
    })
  },
  async created(){
    this.envConfigs = await this.GetEnvConfigData({
                //context: data.id,
                role: 'admin'
            });
  },
  methods: {
    getEnvValue(name, env){
        let value = ''
        this.envConfigs.forEach(({ serviceName, envs}) => {
            if(serviceName === name){
                envs.forEach((envObj) => {
                    if(envObj.key === env){
                        value =  envObj.value
                    }
                });
            }
        })
        return value
    },
    getLoadbalancer(){
        const cubes = this.getEnvValue('ordermanager', 'cubes')
        const [loadbalancerServer] = cubes.split(" ")
        this.loadbalancer = loadbalancerServer
    },
    ...mapActions([
        "getContextNotifications", 
        "GetEnvConfigData", 
        "GetSetupDataById", 
        "UpdateShop", 
        "UpdateShopsEnvsBulk", 
        "GetEnvsBulkConfigData",
        "setRedirectionAsync",
        "deleteRedirectionAsync",
      ]),
    barcodeChanged(value) {
      this.shop.barcodeProduct = value;
    },
    currencyChanged(value) {
      this.shop.currency = { code: value };

      let isCurrency = false;
      let currencyObjectOptions = [];
      this.envConfigs.forEach(({ serviceName, envs }) => {
        if (serviceName === "webapp" || serviceName === "templates") {
          envs.forEach(envObj => {
            if (serviceName === "templates" && envObj.key === "currency") {
              envObj.value = value;
              currencyObjectOptions = envObj.options;
            }
            if (serviceName === "webapp" && envObj.key === "currency") {
              envObj.value = value;
              isCurrency = true;
            }
          });
        }
        if (serviceName === "webapp" && !isCurrency) {
          if (!isCurrency) {
            envs.push({
              key: "currency",
              value: value,
              show: false,
              onlyForAdmin: true,
              inputType: "select",
              options: currencyObjectOptions
            });
            isCurrency = true;
          }
        }
      });
    },
    printcubeBrandChanged (value) {
        let flag = false;
        let printcubeBrandOptions = [];
        this.envConfigs.forEach(({ serviceName, envs}) => {
            if(serviceName === 'webapp'){
                envs.forEach((envObj) => {
                    if( serviceName === 'webapp' && envObj.key === 'printcube_brand'){
                        envObj.value = value;
                        printcubeBrandOptions = envObj.options;
                        flag = true;
                    }
                });
            }
            if((serviceName === 'webapp' || serviceName === 'translations') && !flag){
                if(!flag) {
                    envs.push({
                        key: 'printcube_brand',
                        value: value,
                        show: false,
                        onlyForAdmin: true,
                        inputType: 'select',
                        options: printcubeBrandOptions
                    });
                    flag = true;
                }
            }
        });
    },
    showEanChanged(value) {
      this.shop.showEAN = value;
    },
    proxyChanged(value) {
      if(this.shop.installation) {
          this.shop.installation.proxy = value;
      }else {
          this.shop.installation = { proxy: value }
      }
    },
    testregistryChanged(value){
      if(this.shop.installation) {
          this.shop.installation.testregistry = value;
      }else {
          this.shop.installation = { testregistry:  value }
      }
    },
    async save(){
        const selectedContexts = this.selectedShops.map(shop => shop.id)
        await this.UpdateShopsEnvsBulk({contexts: selectedContexts, config: this.envConfigs, shop: this.shop})
        this.getLoadbalancer();
        console.log("loadblanacer save", this.loadbalancer);
        if(this.loadbalancer)
          await this.setRedirectionAsync({url: this.loadbalancer, context: selectedContexts })
        else await this.deleteRedirectionAsync({ context: selectedContexts })
        this.$router.push({ name: 'Shops'});
    }
  }
};
</script>

<style lang="scss">
</style>
